import { configureStore } from '@reduxjs/toolkit';
import messagesReducer from '../reducers/messagesReducer';
import loadingReducer from '../reducers/loadingReducer';
import promptBarReducer from '../reducers/promptBarReducer';
import authReducer from '../reducers/authReducer';
import selectedTileReducer from '../reducers/selectedTileReducer';
import uiReducer from '../reducers/uiReducer';
import documentsReducer from '../reducers/documentsReducer';
import datasetsReducer from '../reducers/datasetsReducer';
import promptsReducer from '../reducers/promptsReducer';
import adminReducer from '../reducers/adminReducer'; // Import the admin reducer
import { jwtDecode } from 'jwt-decode';

const reducers = {
    ui: uiReducer,
    documents: documentsReducer,
    datasets: datasetsReducer,
    prompts: promptsReducer,
    messages: messagesReducer,
    loading: loadingReducer,
    promptBar: promptBarReducer,
    auth: authReducer,
    selectedTile: selectedTileReducer,
};


// Check if user is admin from local token storage
const token = localStorage.getItem('token');
let isAdmin = false;

if (token) {
    const decodedToken = jwtDecode(token);
    isAdmin = decodedToken.role === 'admin';
}

// Conditionally add the admin reducer if the user's role is 'admin'
if (isAdmin) {
    reducers.admin = adminReducer;
}

const store = configureStore({
    reducer: reducers,
});

export default store;